module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-05-231a34dab34bb93213853c1830f2c3fd.webp";